import { FC, useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { cx } from "@emotion/css";
import { Form, message } from "antd";

import { useMutation } from "@tanstack/react-query";
import Footer from "../OTP/Footer";
import { useIntl } from "react-intl";

interface OTPStepProps {
  phone: string;
  countryCode: string;
  verifyOTP: (...rest: any[]) => any;
  reSendOtp: () => any;

  onLoginSuccess?: (res: any) => void;
  onLoginError?: (err: any) => void;
}

const OTPStep: FC<OTPStepProps> = ({
  reSendOtp,
  phone,
  countryCode,

  verifyOTP,
  onLoginError,
  onLoginSuccess,
}) => {
  const intl = useIntl();
  const { mutate, isError, isSuccess, data } = useMutation(verifyOTP);
  const [isCodeWrong, setIsCodeWrong] = useState<boolean | null>(null);
  const [code, setCode] = useState("");

  const validateOTP = () => {
    mutate(
      { phone, code, phone_country_code: countryCode },

      {
        onSuccess: (res: any) => {
          if (res?.code !== "ERR_BAD_REQUEST") {
            setIsCodeWrong(false);
            if (onLoginSuccess) {
              onLoginSuccess(res);
            } else {
            }
          } else {
            setIsCodeWrong(true);
            message.error(res?.response?.data[0]);
            if (onLoginError) {
              onLoginError(res);
            }
          }
        },
        onError: (err: any) => {
          message.error(err?.response?.data?.message);
          if (onLoginError) {
            onLoginError(err);
          }

          setIsCodeWrong(true);
        },
      }
    );
  };

  useEffect(() => {
    if (code.length === 6) {
      validateOTP();
    }
  }, [code]);
  return (
    <div className="space-y-4">
      <p className="text-center font-semibold">
        {intl.formatMessage({ id: "OTP" })}
      </p>
      <Form.Item name="code">
        <div
          dir="ltr"
          className={cx("flex justify-center", { error: isCodeWrong })}
        >
          <OTPInput
            value={code}
            onChange={(val) => setCode(val)}
            numInputs={6}
            renderSeparator={<span className="inline-block w-[16px]" />}
            renderInput={(props) => (
              <input
                disabled={isCodeWrong === false}
                {...props}
                style={{
                  width: "35px",
                  height: "42px",
                  textAlign: "center",
                  fontSize: "16px",
                  border: `0.8px solid var(--Light-border, ${
                    isCodeWrong === null
                      ? "#B0B0C0"
                      : isCodeWrong === true
                      ? "#C43535"
                      : "#479821"
                  })`,
                  borderRadius: "8px",
                  background: "white",
                  outline: "none",
                  color: `${
                    isCodeWrong === null
                      ? "black"
                      : isCodeWrong === true
                      ? "#C43535"
                      : "#479821"
                  }`,
                }}
              />
            )}
          />
        </div>
            
      </Form.Item>
      <Footer isCodeWrong={isCodeWrong} reSendOtp={reSendOtp} />
    </div>
  );
};

export default OTPStep;
